import React from "react";
import MainTasksTable from "./Serving/PriorityTableComponents/MainTasksTable";
import ProfileCard from "./Serving/ProfileCard";
import NewsFeedCard from "./Serving/NewsFeedCard";
import WelcomeText from "./Serving/PriorityTableComponents/WelcomeText";

import "../style/home.css";

export default function Home() {

    return (
        <>
            <div className="home-top-container">
                <div className="left-aligned-container">
                    <WelcomeText/>
                </div>
                <div className="right-aligned-container">
                    <ProfileCard/>
                    <NewsFeedCard/>
                </div>
            </div>
            <div className="home-2nd-container">
                <div>
                    <MainTasksTable/>
                </div>
            </div>
        </>
    );
}

